{
  "collapse": "Sbalit",
  "expand": "Roztáhnout"
}
